export const parentFeatureConstants = Object.freeze({
  ORDERS: 'Orders',
  INVENTORY: 'Inventory',
})
